/**-----------------------------------------------------------------------------------------
* Copyright © 2023 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the package root for more information
*-------------------------------------------------------------------------------------------*/
"use client";
import * as t from "react";
import { dispatchEvent as i, validatePackage as c, classNames as r } from "@progress/kendo-react-common";
const n = {
  name: "@progress/kendo-react-listview",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1702645192,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/components/my-license/"
};
class d extends t.PureComponent {
  constructor(l) {
    super(l), this.onScroll = (s) => i(this.props.onScroll, s, this, void 0), c(n);
  }
  /**
   * @hidden
   */
  render() {
    const { data: l = [], item: s } = this.props;
    return /* @__PURE__ */ t.createElement(
      "div",
      {
        className: r("k-listview k-d-flex", this.props.className),
        style: this.props.style
      },
      this.props.header ? /* @__PURE__ */ t.createElement(this.props.header, null) : null,
      /* @__PURE__ */ t.createElement("div", { role: "list", className: "k-listview-content", onScroll: this.onScroll }, s && l.map((o, a) => /* @__PURE__ */ t.createElement(s, { dataItem: o, index: a, key: a }))),
      this.props.footer ? /* @__PURE__ */ t.createElement(this.props.footer, null) : null
    );
  }
}
const p = (e) => /* @__PURE__ */ t.createElement("div", { className: r("k-listview-header", e.className), style: e.style }, e.children), h = (e) => /* @__PURE__ */ t.createElement("div", { className: r("k-listview-footer", e.className), style: e.style }, e.children);
export {
  d as ListView,
  h as ListViewFooter,
  p as ListViewHeader
};
